import { ReactNode } from 'react';

import Icon from '@components/icon/Icon';
import Tooltip from '@components/tooltip/Tooltip';

import theme from '../../../themes/colors';

interface InfoIconTooltipProps {
  id: string;
  tooltipText?: string;
  classname?: string;
  children?: ReactNode;
}

const InfoIconTooltip = ({
  id,
  tooltipText,
  classname,
  children
}: InfoIconTooltipProps) => (
  <>
    <Icon
      name="alert-circle"
      className="text-grey40"
      stroke={theme.subText}
      data-tooltip-id={`${id}-info-icon`}
    />
    <Tooltip
      id={`${id}-info-icon`}
      type={tooltipText ? 'text' : 'custom'}
      tooltipText={tooltipText}
      className={`leading-5 ${classname || ''}`}
    >
      {children}
    </Tooltip>
  </>
);

export default InfoIconTooltip;
